// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideZap as RawLucideZap } from "lucide-react";
export const LucideZap = /* @__PURE__ */ createIcon(RawLucideZap, "LucideZap", 2);
